import canyonSrc from "@/assets/home-new/panels/canyon.avif"
import cliffsSrc from "@/assets/home-new/panels/cliffs.avif"
import icebergsSrc from "@/assets/home-new/panels/icebergs.avif"

// The launch landscapes, one per product section so none repeats.
const panelArt = {
  cliffs: { src: cliffsSrc, position: "object-[50%_60%]" },
  icebergs: { src: icebergsSrc, position: "object-[50%_55%]" },
  canyon: { src: canyonSrc, position: "object-[60%_60%]" },
} as const

export type HomeNewPanelArt = keyof typeof panelArt

/**
 * The backdrop for each product section's large visual panel: a launch
 * landscape under a 25% night-blue wash, so the cards on top sit back from
 * it. Fills its positioned parent.
 */
export function HomeNewPanelBackdrop({ art }: { art: HomeNewPanelArt }) {
  const { src, position } = panelArt[art]
  return (
    <>
      <img
        src={src}
        alt=""
        width={1600}
        height={1066}
        loading="lazy"
        decoding="async"
        className={`absolute inset-0 size-full object-cover ${position}`}
      />
      <div className="absolute inset-0 bg-[#081C26]/25" />
    </>
  )
}
